import { OpenInNew } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import LinkedInProfileLink from "app/pages/sales-intelligence/common-components/LinkedInProfileLink/LinkedInProfileLink";
import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import { isRoleChangesSignalEventWithLinkedIn } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

type SignalEventBoxItemProps = {
    signal: SignalEventDto;
    onArticleLinkClick: (signalEvent: SignalEventDto) => void;
    onLinkedInLinkClick: (signalEvent: SignalEventDto) => void;
};

const SignalEventBoxItemFooter = ({ signal, onArticleLinkClick, onLinkedInLinkClick }: SignalEventBoxItemProps) => {
    const { eventHappenedDaysAgo, type } = signal;

    const handleArticleLinkClick = () => onArticleLinkClick(signal);
    const handleLinkedInLinkClick = () => onLinkedInLinkClick(signal);

    return (
        <Flex
            alignItems="center"
            gap="12px"
        >
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[250]}
                data-automation="signal-event-date"
            >
                {signalEventsService.getSignalEventDate(eventHappenedDaysAgo)}
            </Text>
            {type === SignalType.News && signal.url ? (
                <>
                    <Box
                        width="5px"
                        height="5px"
                        borderRadius="50%"
                        background={colorsPalettes.carbon[100]}
                    />
                    <Text
                        as="a"
                        fontVariant="caption"
                        display="inline-flex"
                        alignItems="center"
                        gap="4px"
                        textDecoration="none"
                        color={colorsPalettes.carbon[250]}
                        whenHover={{ color: colorsPalettes.carbon[400] }}
                        href={signal.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleArticleLinkClick}
                        data-automation="signal-event-news-link"
                    >
                        {translate("si.company-analysis.signals.card.article")}
                        <OpenInNew
                            size={12}
                            color="currentColor"
                        />
                    </Text>
                </>
            ) : null}
            {isRoleChangesSignalEventWithLinkedIn(signal) ? (
                <>
                    <Box
                        width="5px"
                        height="5px"
                        borderRadius="50%"
                        background={colorsPalettes.carbon[100]}
                    />
                    <LinkedInProfileLink
                        linkedinId={signal.linkedinId}
                        dataAutomation="signal-event-linkedin-link"
                        onMouseDown={handleLinkedInLinkClick}
                    />
                </>
            ) : null}
        </Flex>
    );
};

export default SignalEventBoxItemFooter;
